import { Component, Input, OnInit } from '@angular/core';
import { EntityBase } from 'globals/store/entity.shared.data';
import { CoreEntityType } from 'globals/store/share.data';
import { Wrapper } from '../wrapper.component';
import { JoiEvent, Ranking } from 'globals/store/events.data';
import { chooseOrAddEntityTypes, ChooseOrAddTypesData } from 'src/app/modules/performers/performerSharedFunctions';
import { EntityServiceFunctions } from 'globals/store/entity.data';
import { Observable } from 'rxjs';
import { titleCase } from 'src/app/helpers/helpers';
import { Asset } from 'globals/store/assets.data';
import { MenuHoverButtonComponent } from '../buttons/menu-hover-button.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'entity-types',
    template: `
<menu-hover-button 
  id="entity-type"
  [readOnly]="readOnly"
  *ngIf="!!entity && { type: (entityTypes && entityTypes[entity.entityTypeId || ''] ? entityTypes[entity.entityTypeId].name : null) } as vars"
  [iconSelector]="icon"
  [hoverText]="hoverText" 
  [text]="vars.type || hoverText"
  [lightText]="!vars.type"
  [tooltipLeft]="true"
  (click)="readOnly ? null : manageEntityType()">
</menu-hover-button>
`,
    standalone: true,
    imports: [MenuHoverButtonComponent, CommonModule],
})
export class EntityTypesComponent<E extends EntityBase | Asset> extends Wrapper<EntityTypesComponent<E>> implements OnInit {
  @Input() entity: E
  @Input() entityType: CoreEntityType | 'asset'
  @Input() readOnly: boolean = true

  entityTypes: { [id:string]: Ranking } = {}
  icon: string
  hoverText: string
  event: JoiEvent
  service: EntityServiceFunctions

  
  ngOnInit() {
    this.subProp(this.store.select('events', 'event'), 'event')
    let typesObservable: Observable<{ [id:string]: Ranking }>

    switch (this.entityType) {
      case 'attendee':
        this.icon = 'ATTENDEES'
        this.hoverText = 'Attendee type'
        this.service = this.attendeeService
        typesObservable = this.store.select('attendees', 'attendeeTypes')
        break
      case 'asset':
        this.icon = null
        this.hoverText = 'Asset Category'
        this.service = this.assetService
        typesObservable = this.store.select('assets', 'assetCategories')
        break
      case 'performer':
      this.icon = 'PERFORMERS24'
        this.hoverText = 'Performer type'
        this.service = this.performerService
        typesObservable = this.store.select('performers', 'performerTypes')
        break
      case 'exhibitor':
        this.icon = 'EXHIBITORS_24'
        this.hoverText = 'Exhibitor type'
        this.service = this.exhibitorService
        typesObservable = this.store.select('exhibitors', 'exhibitorTypes')
        break
      case 'resource':
        this.icon = 'RESOURCES48'
        this.hoverText = 'Resource type'
        this.service = this.resourceService
        typesObservable = this.store.select('resources', 'resourceTypes')
        break

      default:
        console.log(`Missing handling for ${this.entityType}`)
        return
    }

    this.subProp(typesObservable, 'entityTypes')
  }

  async manageEntityType() {
    const rect = (<HTMLElement>document.getElementById('entity-type')).getBoundingClientRect()
    const position = { top: rect.bottom - 2, left: rect.left }

    const data: ChooseOrAddTypesData<EntityServiceFunctions, E> = {
      position, 
      dialog: this.dialog, 
      entityService: this.service, 
      types:  this.entityType === 'performer' ? this.event.performerTypes : 
              this.entityType === 'exhibitor' ? this.event.exhibitorTypes :
              this.entityType === 'asset' ? this.event.assetCategories : 
              this.entityType === 'attendee' ? this.event.attendeeTypes :
              this.event.resourceTypes,
      entities: [this.entity],
      single: true,
      typeName: titleCase(this.entityType),
      isCategory: this.entityType === 'asset',
      canDeselect: this.entityType === 'asset'
    }
    await chooseOrAddEntityTypes(data)
  }


}

